import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import { Winning } from '../types/prize.types';
import i18n from '../i18n';
import { PRIZE_TYPE } from '../constants/sort';

const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
};

const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    }).format(date);
};

const formatTax = (winning: Winning) => {
    return winning?.paymentAmount === 0 && winning?.withholdingAmount === 0
        ? i18n.t('epic.esport.prizes.status.pending')
        : formatCurrency(winning.withholdingAmount);
};

const formatPayout = (winning: Winning) => {
    return winning?.paymentAmount === 0
        ? i18n.t('epic.esport.prizes.status.pending')
        : formatCurrency(winning.paymentAmount);
};

interface HeaderData {
    label: string;
    value: string;
}

export const usePrizeHeaderData = (winning: Winning): HeaderData[] => {
    const { t } = useTranslation();
    return useMemo(
        () => [
            { label: t('epic.esport.prizes.list.header.event'), value: winning.eventName },
            {
                label: t('epic.esport.prizes.list.header.date'),
                value: formatDate(winning.dateOfEvent)
            },
            {
                label: t('epic.esport.prizes.list.header.type'),
                value:
                    winning.prizeType === PRIZE_TYPE.CASH
                        ? t('epic.esport.label.prize.payout_type.cash')
                        : t('epic.esport.label.prize.payout_type.pg')
            },
            {
                label: t('epic.esport.prizes.list.header.price'),
                value: formatCurrency(winning.winningAmount)
            },
            { label: t('epic.esport.prizes.list.header.tax'), value: formatTax(winning) },
            { label: t('epic.esport.prizes.list.header.payment'), value: formatPayout(winning) }
        ],
        [winning]
    );
};
